import Image from "../../components/general/Image";
import Button from "../../components/general/Button";
import { HiringStepsIcon1, HiringStepsIcon2, HiringStepsIcon3, HiringStepsIcon4 } from "../../constants/ImagePaths";
import { HiringStepsBackground } from "../../constants/ImagePaths";
import { ROUTES } from "../../routes/RouteList";
import { ArrowUpRight } from "../../components/common/Icons";


const hiringSteps = [
  { img: HiringStepsIcon1, title: <>Submit a <br /> free request </>, desc: <>Tell us what you're looking for — explore pre-vetted developers ready to interview.</> },
  { img: HiringStepsIcon2, title: <>Share your  <br /> project needs</>, desc: <>Hop on a quick call to align on skills, timelines, and get a tailored estimate.</> },
  { img: HiringStepsIcon3, title: <>Meet top <br /> candidates</>, desc: <>Review 2–3 carefully matched developers within 24–48 hours — interview and assess fit.</> },
  { img: HiringStepsIcon4, title: <>Hire and  <br /> onboard easily </>, desc: <>We handle contracts, payments, and admin — you focus on scaling your team with confidence.</> }
]

const HiringProcessSection = ({ selected_skill }) => {
  const backgroundStyles = {
    backgroundImage: `url(${HiringStepsBackground})`,
    backgroundSize: 'cover',
    backgroundPosition: 'initial',
    backgroundRepeat: 'no-repeat'
  }

  return (
    <section className="-mt-[40px] !pt-[100px] md:!pt-[100px] !pb-[50px] lg:!pb-[50px] lg:!pt-[100px] bg-black" style={backgroundStyles}>
      <div className="--layout-padding max-width text-white">
        <div className="highRiskCon">
          <div className="highRiskText">
            <h3 className="text-[30px] lg:text-55 text-center font-semibold">
              How to hire {selected_skill} <br className="hidden lg:block" /> through <span className='text-primary-color'> DevHire</span>
            </h3>
          </div>
          <div className="mt-[20px] lg:mt-[50px]">
            <ul className='flex flex-col md:grid md:grid-cols-2 gap-[30px] lg:grid-cols-4 justify-center'>
              {
                hiringSteps.map((step, index) => (
                  <li key={index} className={index !== 0 ? 'lg:border-l lg:border-[#787878] lg:pl-[30px]' : ''}>
                    <figure className='mb-[20px]'><Image src={step.img} className='mx-auto w-[100px]' alt="" /></figure>
                    <h4 className='text-[20px] font-semibold text-center'> {step.title} </h4>
                    <p className='text-[14px] text-center mt-[10px]'> {step.desc} </p>
                  </li>
                ))
              }
            </ul>
          </div>
          <div className="text-center my-[20px] md:my-[50px] lg:my-0 lg:mt-[50px]">
            <Button className='bg-primary-color text-black w-[200px] h-[50px] mx-auto rounded text-[16px]' href={ROUTES.START_HIRING}>
              <div className="flex items-center justify-center gap-2">
                <span>Hire with confidence</span>
                <ArrowUpRight className="w-4 h-4" />
              </div>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HiringProcessSection;